import { useMemo } from 'react'
import { useI18n } from 'builder/hooks/useI18n'

import { UserData } from 'builder/modules/user'
import TrSelectResumeImage from '../../../assets/TrSelectResume.png'
import LogoSignTrImgSrc from '../../../assets/logo_sign_tr.svg'

import * as Styles from '../styles'
import { LoadingState, ProcessingState } from '../ResumeProcessing/ResumeProcessing'
export const TRANSLATION = `builder.auto_apply.resume_select`

type Props = {
  resumeTitle?: string
  onClick: () => void
  isLoading: boolean
  whiteLabelBrand?: UserData['scopes']['kind']
  isDulpicationLoading: boolean
}

export const TRResumeSelection = ({
  resumeTitle,
  onClick,
  isLoading,
  whiteLabelBrand,
  isDulpicationLoading,
}: Props) => {
  const { i18n } = useI18n()

  const brand = useMemo(() => {
    if (whiteLabelBrand === 'TR') {
      return 'TopResume'
    }

    if (whiteLabelBrand === 'TOP_CV') {
      return 'TopCV'
    }

    return 'Expert'
  }, [whiteLabelBrand])

  if (isLoading || isDulpicationLoading) {
    return (
      <Styles.Box>
        {isLoading && <LoadingState />}
        {isDulpicationLoading && <ProcessingState />}
      </Styles.Box>
    )
  }

  return (
    <Styles.Box onClick={onClick} style={{ width: '100%', maxWidth: '448px' }}>
      {brand && (
        <Styles.Badge>
          <img src={LogoSignTrImgSrc} />
          <div>From {brand}</div>
        </Styles.Badge>
      )}
      <Styles.ImageContainer>
        <Styles.Image $image={TrSelectResumeImage} />
      </Styles.ImageContainer>
      <Styles.TextContainer>
        <Styles.Header $isTrCard>{resumeTitle}</Styles.Header>
        <Styles.Description>{i18n.t(`${TRANSLATION}.expert_resume_subtitle`)}</Styles.Description>
      </Styles.TextContainer>
    </Styles.Box>
  )
}
